import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import GlobalButton from "../../../components/CustomButton";
import appcolors from "../../../constants/Colors";
import { CURRENCY } from "../../../constants/Variables";
import { t } from "i18next";

const style = {
  cardContainer: {
    border: "2px solid #E7E9ED",
    padding: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    // height: "100%",
    backgroundColor: "#ffffff",
  },
  dollarIcon: {
    fontWeight: 600,
    fontSize: "0.8rem",
    color: appcolors.black,
    fontFamily: "GiloryBold",
  },
  price: {
    fontWeight: 600,
    fontSize: "2rem",
    color: appcolors.black,
    fontFamily: "GiloryBold",
  },
  duration: {
    fontWeight: 300,
    fontSize: "0.8rem",
    color: appcolors.black,
    marginLeft: "4px",
  },
};

function SubscriptionCard({ data, setIsLoading, handleUpdateSubscription }) {
  const dispatch = useDispatch();
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  // const handleUpdateSubscription = async (subscription) => {
  //   try {
  //     setIsLoading(true);
  //     const response = await supplierUpdateSubscription(userData?._id, {
  //       subscriptionId: subscription?._id,
  //     });
  //     if (response?.data.status === "success") {
  //       const data = response?.data?.data;
  //       const updatedData = { ...userData, ...data };
  //       localStorage.setItem("user-data", JSON.stringify(updatedData));
  //       dispatch(setUserData(updatedData));
  //       handleOpenSnackBar("success", response.data.message);
  //       let payload = {
  //         userId: data?._id,
  //         userType: "supplier",
  //         subscriptionId: data?.subscriptionId,
  //         price: subscription?.price,
  //         duration: "monthly",
  //         startDate: new Date(),
  //         transactionId: "378e3wd32e32w2",
  //       };
  //       await createSubscriptionHistory(payload);
  //     } else {
  //       handleOpenSnackBar("error", response.data.message);
  //     }
  //   } catch (error) {
  //     handleOpenSnackBar("error", error?.message);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  return (
    <Grid container spacing={1} mt={3} justifyContent={"center"}>
      {data?.map((val, index) => {
        console.log(val,"valvalvalvalvalval")
        return (
          <Grid key={index} item xs={12} sm={6} md={3}>
            <Box sx={style.cardContainer}>
              <Box>
                <Typography
                  variant="h3"
                  color={"#473BF0"}
                  fontSize={"0.875rem"}
                  textTransform={"uppercase"}
                >
                  {t(val.name[currentLanguage])}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexWrap: "wrap",
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography mt={2} variant="h2" sx={style.price}>
                      <Typography component="span" sx={style.dollarIcon}>
                        {CURRENCY}
                      </Typography>
                      {val.price}
                      <Typography component={"span"} sx={style.duration}>
                        /{t(val.duration)}
                      </Typography>
                    </Typography>
                    <Typography variant="body1" fontFamily={"GiloryLight"}>
                      {t("billed")} {t("monthly")}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography mt={2} variant="h2" sx={style.price}>
                      <Typography component={"span"} sx={style.dollarIcon}>
                        {CURRENCY}
                      </Typography>
                      {val.yearlyPrice ? val.yearlyPrice : 0}
                      <Typography component="span" sx={style.duration}>
                        /{t("yearly")}
                      </Typography>
                    </Typography>
                    <Typography variant="body1" fontFamily={"GiloryLight"}>
                      {t("billed")} {t("yearly")}
                    </Typography>
                  </Box>
                </Box>
                <List sx={{ m: "20px 0" }}>
                  {val.features.map((item, ind) => {
                    const listIcon = (
                      <DoneIcon
                        htmlColor="#68D585"
                        sx={{ fontSize: "1.3rem" }}
                      />
                    );

                    return (
                      <ListItem key={ind} sx={{ padding: "2px 0px" }}>
                        <ListItemIcon sx={{ minWidth: 25 }}>
                          {listIcon}
                        </ListItemIcon>
                        <ListItemText
                          sx={{
                            "& .MuiListItemText-secondary": {
                              color: "#161C2D",
                            },
                          }}
                          secondary={item?.title[currentLanguage]}
                        />
                      </ListItem>
                    );
                  })}
                </List>
              </Box>
              <Box height={50}>
                <GlobalButton
                  variant={"contained"}
                  btnText={"upgrade"}
                  styleProps={{ fontWeight: 400 }}
                  handleClickBtn={() => {
                    handleUpdateSubscription(val);
                  }}
                />
              </Box>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
}

export default SubscriptionCard;
